import Joi from "joi";
import moment from "moment";

// Classes
import AuditableDocument from "./AuditableDocument";

export default class Concession extends AuditableDocument {
	public static schema = Joi.object({
		cardNumber: Joi.string()
			.required()
			.length(9)

			.label("Concession number"),
		letter: Joi.string()
			.required()
			.length(1)
			.regex(/^[a-zA-Z]$/)
			.message('"Concession letter" must be a letter')
			.label("Concession letter"),
		expireAt: Joi.string().length(10).required().label("Expiry"),
	}).options({ abortEarly: false });

	public static sanitise(input: string): string {
		return input.replace(new RegExp(/[_ -]/, "gi"), "");
	}

	/**
	 * DEPRECATED - Using Joi for validation
	 * @param input
	 * @returns
	 */
	public static numberIsValid(input: string): boolean {
		return input.length === 9;
	}

	/**
	 * DEPRECATED - Using Joi for validation
	 * Negation method of Concession.isValid()
	 *
	 * @param input string input
	 * @returns
	 */
	public static numberIsInvalid(input: string): boolean {
		return !Concession.numberIsValid(input);
	}

	/**
	 * DEPRECATED - Using Joi for validation
	 * @param input
	 * @returns
	 */
	public static letterIsValid(input: string): boolean {
		const match = input.match(new RegExp(/^[A-Z]{1}$/, "g"));
		return match !== null;
	}

	/**
	 * DEPRECATED - Using Joi for validation
	 * Negation method of Concession.letterIsValid()
	 *
	 * @param input letter input
	 * @returns true or false
	 */
	public static letterIsInvalid(input: string): boolean {
		return !Concession.letterIsValid(input);
	}

	/**
	 * DO NOT USE YET
	 * @param input
	 * @param requiredLength
	 * @returns
	 */
	public static formatExpiry(
		input: string,
		requiredLength: 7 | 10 = 10
	): string {
		const expiry = super.formatExpiry(input, requiredLength);
		return moment(expiry).format("yyyy-MM-DD");
	}
}
